// angular
import { Component } from '@angular/core';
// other libraries
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-auctions-detail-skeleton',
  standalone: true,
  imports: [
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './auctions-detail-skeleton.component.html',
  styleUrl: './auctions-detail-skeleton.component.scss'
})
export class AuctionsDetailSkeletonComponent {

}
